import { Palette, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { analytics } from '@/services/analytics';
import { WORKSPACE_CANVAS_MODES } from '@/components/workspace/workspaceMode';

const AIArtistIntegrationPage = () => {
  const { t } = useTranslation();

  return (
    <div className="mx-auto flex w-full max-w-4xl flex-col gap-6 px-4 py-10 sm:px-6 lg:px-8">
      <div className="space-y-2">
        <div className="inline-flex items-center gap-2 rounded-full border border-border bg-card px-3 py-1 text-xs font-semibold uppercase tracking-wide text-muted-foreground">
          <Palette className="h-3.5 w-3.5" />
          {t('integrations.aiArtist.title', 'AI Artist app')}
        </div>
        <h1 className="text-3xl font-semibold tracking-tight text-foreground">
          {t('integrations.aiArtist.title', 'AI Artist app')}
        </h1>
        <p className="max-w-2xl text-sm text-muted-foreground">
          {t(
            'integrations.aiArtist.helper',
            'The AI Artist app integration is visible here for awareness and future access, but no connection or settings actions are enabled yet.'
          )}
        </p>
      </div>

      <Card className="border-border/70 bg-muted/20">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Sparkles className="h-5 w-5" />
            {t('integrations.readOnly', 'Read only')}
          </CardTitle>
          <CardDescription>
            {t(
              'integrations.aiArtist.description',
              'A companion app integration for artist workflows and generated artwork handoff.'
            )}
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-wrap gap-3">
          <Button asChild variant="outline">
            <Link
              to={`/studio?canvas=${WORKSPACE_CANVAS_MODES.etsySetup}`}
              onClick={() => analytics.track('button: ui.ai_artist_open_etsy_setup')}
            >
              {t('integrations.etsy.openSetup', 'Open Etsy setup')}
            </Link>
          </Button>
          <Button asChild>
            <Link
              to="/studio"
              onClick={() => analytics.track('button: ui.ai_artist_back_to_studio')}
            >
              {t('integrations.backToStudio', 'Back to Studio')}
            </Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default AIArtistIntegrationPage;
